export enum LoadState {
    Loading,
    Loaded,
    Error,
}

export interface Characteristics {
    supportsCalendar: boolean;
    supportsContacts: boolean;
    supportsMail: boolean;
    supportsSettings: boolean;
    isMicrosoft365Hosted: boolean;
}

export enum M365AuthProvider {
    AAD,
    MSA,
}

export enum MailboxType {
    /**
     * This is the primary mailbox associated with the account
     */
    UserMailbox = 'UserMailbox',

    /**
     * This type represents any Groups that the given user account is part of
     */
    GroupMailbox = 'GroupMailbox',

    /**
     * This type represents Teams Channel scenario e.g. hosting teams channel calendar in outlook calendar
     * TODO: Ideally these are GroupMailboxes in the backend and we should look into cleaning this up and
     * repurpose the GroupMailbox type for this scenario as well
     */
    TeamsMailbox = 'TeamsMailbox',

    /**
     * Mailbox Type to be used for Public folders scenarios.
     * Public folders can be added by right clicking the folders node in left nav in mail module.
     */
    PublicMailbox = 'PublicMailbox',

    /**
     * Mailbox type to be used for shared folders scenario
     */
    SharedMailbox = 'SharedMailbox',

    /**
     * Mailbox type to be used for archive mailbox scenario
     */
    ArchiveMailbox = 'ArchiveMailbox',
}

export interface M365Mailbox {
    type: MailboxType;
    name: string;
    displayName: string;
    emailAddress: string;
    logonEmailAddress: string;
    userIdentity: string;
    routingHint: string;
    authProviderType: M365AuthProvider;
    alternateId: string;
    accountUniqueId: string;
    imageUrl: string;
    profileUrl: string;
}

// Specifies the source of the account information
export enum AccountSourceType {
    Office365 = 'Office365',
    OutlookDotCom = 'Outlook',
    Goolge = 'Google',
    ICloud = 'ICloud',
    Yahoo = 'Yahoo',
}

export interface AccountSource {
    sourceId: string;
    sourceType: AccountSourceType;
    displayName: string;
    characteristics: Characteristics;
    m365mailbox?: M365Mailbox;
}

export interface AccountSourceList {
    loadState: LoadState;
    selectedSourceId: string;
    sources: AccountSource[];
}
